import React, { useEffect } from 'react';

import { useMachine } from '@xstate/react';
import { createMachine } from 'xstate';

import { actions } from './actions';
import { MACHINE_CONFIG } from './config';
import { services } from './services';

export const supplyStepperPageContext = React.createContext({});
export let supplyStepperPageMachine: any;

const MODULE_NAME = 'machines.pageContent';

export const useSMsupplyStepper = (_context: any) => {
  let _machineConfig: any = MACHINE_CONFIG;
  if (_machineConfig && _machineConfig?.context) {
    _machineConfig.context = {
      ..._machineConfig.context,
      ...(_context || {}),
    };
  }
  supplyStepperPageMachine = createMachine(_machineConfig, {
    services,
    actions,
  });
  const [state, send] = useMachine(supplyStepperPageMachine);

  useEffect(() => {
    send({ type: 'START' });
  }, []);

  return {
    supplyStepperPageMachine,
    supplyStepperPageState: state,
    supplyStepperPageSend: send,
  };
};
